/* Size finder modal UI — wired to SizeFinder math engine in size-finder.js */
(function () {
  'use strict';

  var modal = document.getElementById('SizeFinderModal');
  if (!modal || !window.SizeFinder) return;

  var unit = 'metric';
  var baseConfig = { rules: [], fitProfile: 'true_to_size', garmentType: 'top' };

  /* Remember the customer's calculated size and surface it on every
     "Find your size" trigger as a small badge. */
  var STORAGE_KEY = 'sizeFinder:savedSize';

  function savedSize() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function saveSize(size) {
    try {
      window.localStorage.setItem(STORAGE_KEY, size);
    } catch (error) { /* private browsing */ }
  }

  function updateTriggerBadges() {
    var size = savedSize();
    document.querySelectorAll('[data-size-finder-open]').forEach(function (button) {
      var badge = button.querySelector('.size-finder__saved');
      if (!size) {
        if (badge) badge.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'size-finder__saved';
        button.appendChild(badge);
      }
      badge.textContent = size;
    });
  }

  document.addEventListener('sizefinder:result', function (event) {
    if (event.detail && event.detail.size) {
      saveSize(event.detail.size);
      updateTriggerBadges();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateTriggerBadges, { once: true });
  } else {
    updateTriggerBadges();
  }

  var dataEl = document.getElementById('SizeFinderData');
  if (dataEl) {
    try {
      var parsed = JSON.parse(dataEl.textContent) || {};
      baseConfig = window.SizeFinder.parseConfig(parsed);
      window.SizeFinder.setContext({
        fitProfile: baseConfig.fitProfile,
        garmentType: baseConfig.garmentType
      });
    } catch (error) {
      baseConfig = { rules: [], fitProfile: 'true_to_size', garmentType: 'top' };
    }
  }

  /* Per-product size chart: image URL passed on the opener button.
     Products without a chart image simply don't get the button. */
  var chartButton = modal.querySelector('[data-view-chart]');
  var productChart = modal.querySelector('[data-product-chart]');
  var chartImage = modal.querySelector('[data-size-chart-image]');
  var globalChart = modal.querySelector('[data-global-chart]');
  var hasGlobalChart = !!(globalChart && !globalChart.hidden);

  function applyChartContext(opener) {
    var chartUrl = opener ? opener.getAttribute('data-size-chart') : null;

    if (productChart) productChart.hidden = !chartUrl;
    if (chartImage) {
      if (chartUrl) chartImage.src = chartUrl;
      else chartImage.removeAttribute('src');
    }
    if (globalChart) globalChart.hidden = !!chartUrl || !hasGlobalChart;
    if (chartButton) chartButton.hidden = !chartUrl && !hasGlobalChart;
  }

  function readOpenerContext(opener) {
    if (!opener) return;
    window.SizeFinder.setContext({
      fitProfile: opener.getAttribute('data-fit-profile') || baseConfig.fitProfile,
      garmentType: opener.getAttribute('data-garment-type') || baseConfig.garmentType
    });
    var sizesJson = opener.getAttribute('data-available-sizes');
    if (sizesJson) {
      try {
        window.SizeFinder.setContext({ availableSizes: JSON.parse(sizesJson) });
      } catch (error) { /* ignore malformed attribute */ }
    }
    applyChartContext(opener);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-size-finder-open]');
    if (!opener) return;
    event.preventDefault();
    readOpenerContext(opener);
    /* Always land on the finder view, not a stale chart from another product */
    var finder = modal.querySelector('.size-finder-view');
    var chart = modal.querySelector('.size-chart-view');
    if (finder) finder.classList.remove('is-hidden');
    if (chart) chart.classList.remove('is-visible');
    modal.showModal();
  });

  modal.addEventListener('click', function (event) {
    if (event.target === modal || event.target.closest('[data-modal-close]')) modal.close();
  });

  /* Imperial height is entered as feet + inches with an auto ' separator:
     typing 511 renders 5'11. Metric stays a plain number field. */
  var heightField = modal.querySelector('[data-size-height]');

  function setHeightMode() {
    if (!heightField) return;
    if (unit === 'imperial') {
      heightField.type = 'text';
      heightField.setAttribute('inputmode', 'numeric');
      heightField.placeholder = "5'11";
    } else {
      heightField.type = 'number';
      heightField.setAttribute('inputmode', 'decimal');
      heightField.placeholder = '';
    }
    heightField.value = '';
  }

  if (heightField) {
    heightField.addEventListener('input', function () {
      if (unit !== 'imperial') return;
      var digits = heightField.value.replace(/\D/g, '').slice(0, 3);
      heightField.value = digits.length > 1 ? digits.charAt(0) + "'" + digits.slice(1) : digits;
    });
  }

  function parseHeightCm() {
    if (!heightField) return NaN;
    if (unit === 'imperial') {
      var match = heightField.value.replace(/\s/g, '').match(/^(\d)'?(\d{0,2})$/);
      if (!match) return NaN;
      var totalInches = parseInt(match[1], 10) * 12 + parseInt(match[2] || '0', 10);
      return totalInches * 2.54;
    }
    return parseFloat(heightField.value);
  }

  modal.querySelectorAll('[data-unit]').forEach(function (button) {
    button.addEventListener('click', function () {
      unit = button.getAttribute('data-unit');
      modal.querySelectorAll('[data-unit]').forEach(function (el) {
        el.classList.toggle('is-active', el === button);
      });
      modal.querySelectorAll('[data-unit-suffix]').forEach(function (el) {
        el.textContent = unit === 'metric' ? el.getAttribute('data-metric') : el.getAttribute('data-imperial');
      });
      setHeightMode();
    });
  });

  var calcButton = modal.querySelector('[data-size-calc]');
  if (calcButton) {
    calcButton.addEventListener('click', function () {
      var weightInput = modal.querySelector('[data-size-weight]');
      var result = modal.querySelector('.size-finder__result');
      var resultSize = modal.querySelector('.size-finder__result-size');
      var resultNote = modal.querySelector('[data-size-note]');
      var fitNote = modal.querySelector('[data-size-fit-note]');

      var height = parseHeightCm();
      var weight = parseFloat(weightInput.value);

      if (unit === 'imperial') {
        weight = weight * 0.45359237;
      }

      if (isNaN(height) || isNaN(weight) || height <= 0 || weight <= 0) {
        result.classList.add('is-visible');
        resultSize.textContent = '—';
        resultNote.textContent = result.getAttribute('data-text-invalid');
        if (fitNote) fitNote.textContent = '';
        return;
      }

      var recommendation = window.SizeFinder.calculate(height, weight, baseConfig);
      result.classList.add('is-visible');

      if (recommendation.size) {
        resultSize.textContent = recommendation.size;
        resultNote.textContent = result.getAttribute('data-text-match');
        if (fitNote) {
          var fitKey = 'data-text-fit-' + (recommendation.fitProfile || 'true_to_size');
          fitNote.textContent = recommendation.adjusted ? (result.getAttribute(fitKey) || '') : '';
        }
        document.dispatchEvent(new CustomEvent('sizefinder:result', { detail: { size: recommendation.size } }));
      } else {
        resultSize.textContent = '—';
        resultNote.textContent = result.getAttribute('data-text-nomatch');
        if (fitNote) fitNote.textContent = '';
      }
    });
  }

  var finderView = modal.querySelector('.size-finder-view');
  var chartView = modal.querySelector('.size-chart-view');
  modal.querySelectorAll('[data-view-chart]').forEach(function (button) {
    button.addEventListener('click', function () {
      finderView.classList.add('is-hidden');
      chartView.classList.add('is-visible');
    });
  });
  modal.querySelectorAll('[data-view-finder]').forEach(function (button) {
    button.addEventListener('click', function () {
      finderView.classList.remove('is-hidden');
      chartView.classList.remove('is-visible');
    });
  });
})();
